import { render, staticRenderFns } from "./AddSaleFnsTable.vue?vue&type=template&id=5554a9d2&"
import script from "./AddSaleFnsTable.js?vue&type=script&lang=js&"
export * from "./AddSaleFnsTable.js?vue&type=script&lang=js&"
import style0 from "./AddSaleFnsTable.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports